/*** IMPORTS FROM imports-loader ***/
var require = window.require;

/* eslint-disable */
$(document).ready(function () {
  $('#msSupportChatTrigger').click(function (e, data) {
    require([
      'react',
      'react-dom',
      'underscore',
      '@bingads-webui-react/ms-support-chat-modal',
      '@bingads-webui/i18n-amd-loader!shared-components/ms-support-chat-modal'
    ], function (
      React,
      ReactDom,
      _,
      MsSupportChatModal,
      i18n
    ) {
      var accountNumber;
      var authType;
      var virtualAgentInfo;
      var logger;
      var permissions = {
        UnifiedProductSubscription: false,
      };
      var resourcePath;

      var chatCopilotTrigger = function () {
        const detail = {
          eventType: 'action',
          eventData: {
            ActionId: 'liveAgentSupport',
          },
        };
        document.dispatchEvent(new CustomEvent('copilotToggleEvent', { detail }));
        if (_.isFunction(window.apex_glb.closeHelpView)) {
          window.apex_glb.closeHelpView();
        }
      };

      try {
        var pageContext = require('PageContext');

        accountNumber = pageContext.CurrentAccount && pageContext.CurrentAccount.AccountNumber;
        authType = pageContext.authenticationType;
        if (pageContext.FeaturePilotFlag && pageContext.FeaturePilotFlag.isVirtualAgentEnabled) {
          virtualAgentInfo = {
            market: pageContext.market,
          }
        }

        permissions.UnifiedProductSubscription = pageContext.Permissions && pageContext.Permissions.dynamic && pageContext.Permissions.dynamic.UnifiedProductSubscription;
        resourcePath = pageContext.SupportPagePath;
      } catch (e) { }

      require(['component/config/index', 'instrumentation/log', '@bingads-webui-react/copilot-utils'], (conf, log, copilotUtils) => {
        var isCopilotEnabledForCurrentMode = pageContext.isSmartMode === false && pageContext.isUpSmartMode === false;
        new Promise((resolve) => {
          const { isCopilotRegionRestricted } = copilotUtils || {};
          const isAdsCopilotFraudRestrictionEnabled = pageContext.Permissions.dynamic.AdsCopilotFraudRestriction;
          if (isCopilotEnabledForCurrentMode && _.isFunction(isCopilotRegionRestricted)) {
            if (isAdsCopilotFraudRestrictionEnabled) {
              // if fraud restriction pilot is on, we can use live agent only mode instead of legacy live agent popup
              resolve(false);
            } else {
              const serverContext = { cid: pageContext.cid, aid: pageContext.aid };

              // check if copilot is region restricted
              resolve(isCopilotRegionRestricted({
                feature: 'Chat',
                permissions: pageContext.Permissions,
                serverContext,
              }));
            }
          } else {
            // copilot is not supported in smart mode, no need to check region restriction
            resolve(true);
          }
        }).then((isCopilotRegionRestricted) => {
          var isCopilotEnabled = isCopilotEnabledForCurrentMode && !isCopilotRegionRestricted;

          if (isCopilotEnabled) {
            // render support chat inside copilot UI
            log.trace('copilot live agent support triggered from ms-chat-support');
            chatCopilotTrigger();
          } else {
            // render support chat inside virtual agent popup
            if (!accountNumber) {
              var currentAccount = conf.get('CurrentAccount');
              accountNumber = currentAccount && currentAccount.AccountNumber;
            }
            logger = log;
            renderModal();
          }
        }).catch((e) => {
          renderModal();
        });
      });

      var renderModal = function () {
        var modal = React.createElement(MsSupportChatModal.MsSupportChatModal, {
          isOpen: true,
          virtualAgentInfo: virtualAgentInfo,
          authType: authType,
          onClose: close,
          logger: logger,
          i18n: i18n,
          market: data && data.market,
          permissions: permissions,
          resourcePath: resourcePath,
          featureName: permissions.UnifiedProductSubscription ? 'UP' : undefined,
          context: { accountNumber: accountNumber, flowId: permissions.UnifiedProductSubscription ? 'Subscription-ads-main' : 'EXP-main-cc' }
        });
        ReactDom.render(modal, document.getElementById('msSupportChatModalContainer'));
      };

      var close = function () {
        ReactDom.unmountComponentAtNode(document.getElementById('msSupportChatModalContainer'));
      };
    });
  });
});

